module.exports = __webpack_public_path__ + "static/media/task.a5a80e85.svg";